module.exports = __webpack_public_path__ + "img/logo.35abcd65.png";